import { of, EMPTY } from 'rxjs'
import { switchMap, take } from 'rxjs/operators'
import { brand$ } from './brand'
import { isStaffMember$ } from './staff'

const PAYMEYOU_CONFIG = window.ui.payMeYouConfig || {}
const PAYMEYOU_BRANDS = Object.keys(PAYMEYOU_CONFIG)

function isPayMeYouBrand$(brand) {
  return of(PAYMEYOU_BRANDS.includes(brand.get('id')))
}

function getPayMeYouConfigFor$(brand) {
  return of(PAYMEYOU_CONFIG[brand.get('id')])
}

export const isPayMeYouEnabled$ = isStaffMember$.pipe(
  switchMap(isStaffMember =>
    isStaffMember
      ? brand$.pipe(take(1), switchMap(isPayMeYouBrand$))
      : of(false)
  )
)

export const payMeYouConfig$ = isPayMeYouEnabled$.pipe(
  switchMap(isPayMeYouEnabled =>
    isPayMeYouEnabled
      ? brand$.pipe(take(1), switchMap(getPayMeYouConfigFor$))
      : EMPTY
  )
)
